import React from 'react';
import ReactiveListeningStatus from '../Global/ReactiveListeningStatus/ReactiveListeningStatus';

export default function FreeAnswerMic({ volumeLevel }) {
  return (
    <div className="freeAnswer__mic">
      <ReactiveListeningStatus volumeLevel={volumeLevel || 0} />
    </div>
  );
}
